<template>
  <b-form-rating
    class="ratingquality"
    id="rating-inline"
    inline
    :value="ratingStars"
    readonly
    :variant="maxRating ? 'warning' : 'primary'"
    no-border
  ></b-form-rating>
</template>

<script>
export default {
  name: "Rating",
  props: {
    rating: Number,
  },
  computed: {
    ratingStars() {
      if (this.rating!=null) {
        return this.rating;
      }else{
        return 0;
      }
    },
    maxRating() {
      if (this.rating == 6) return true;
      else return false;
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.ratingquality span {
  padding: 0.05em !important;
}
</style>